import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PatientCurrentMedicationApi } from '../api/patientcurrentmedication.api';
import { switchMap, map } from 'rxjs/operators';
import { PatientCurrentMedicationData, PatientCurrentMedication } from '../../../interfaces/masters/patientcurrentmedication' ;
@Injectable()
export class PatientCurrentMedicationService extends PatientCurrentMedicationData {

    constructor(private api: PatientCurrentMedicationApi) {
      super();
    }
  
  
    list(url: string): Observable<PatientCurrentMedication[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<PatientCurrentMedication>{
        return this.api.getById(url);
    }
  
    create(url: string, data:PatientCurrentMedication): Observable<PatientCurrentMedication[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:PatientCurrentMedication): Observable<PatientCurrentMedication> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  